import { Box, Typography, Grid } from '@mui/material'
import React, { useState, useContext, useMemo } from 'react'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import moment from 'moment'
import { CheckoutContext } from '../../../../contexts/CheckoutContext'
import { IoIosArrowForward } from 'react-icons/io'
import RouterHook from '../../../../contexts/RouterHook'
import { AuthContext } from '../../../../contexts/AuthContext'
import { LocalStorage, Services } from '../../../../services'
import { AgendamentoContext } from '../../../../contexts/AgendamentoContext'

export default function ResumoAgendConf() {
  const serverRouter = RouterHook()
  const { sttAuthCtx } = useContext(AuthContext)
  const { sttPg, actionsCtxEmps } = useContext(EmpresasContext)
  const { actionsChkt } = useContext(CheckoutContext)
  const { sttCtxAgend } = useContext(AgendamentoContext)

  const [discountValue, setDiscountValue] = useState(0)

  const reagendamento = sttCtxAgend.reagendamento

  const pagamentoLocal = reagendamento
    ? reagendamento.formaPagamento === 'MAQUINA_CARTAO' ||
      reagendamento.formaPagamento === 'LOCAL' ||
      reagendamento.formaPagamento === 'DINHEIRO'
    : false

  const calculateTotalValue = useMemo(() => {
    const selectedHorarios = sttPg.selectedHorarios
    let totalValue = 0
    let totalDiscount = 0

    // Agrupa horários pela grade
    const groupedByGrade = selectedHorarios.reduce((acc, horario) => {
      const gradeId = horario.idgrade
      if (!acc[gradeId]) acc[gradeId] = []
      acc[gradeId].push(horario)
      return acc
    }, {})

    Object.values(groupedByGrade).forEach(horarios => {
      const firstHorario = horarios[0]
      // Verifica se a quadra tem grade de horários
      const grade = sttPg.selectedQuadra.grades.find(g => g.idgrade === firstHorario.idgrade)

      // Soma de valores já existentes (promoções pontuais)
      let gradeTotalValue = horarios.reduce((sum, h) => {
        if (h.valorPromocional) totalDiscount += h.valor - h.valorPromocional
        return sum + (h.promocao ? h.valorPromocional : h.valor)
      }, 0)

      // Aplica desconto progressivo (ou único se progressao == null)
      if (grade && grade.descontoProgressivo !== null) {
        const { minimo, progressao, valor } = grade.descontoProgressivo
        // calcula duração total em minutos
        const totalDuration = horarios.reduce(
          (sum, h) => sum + moment(h.dataFinal).diff(moment(h.dataInicio), 'minutes'),
          0,
        )

        if (totalDuration >= minimo) {
          let totalGradeDiscount = 0
          if (progressao) {
            // desconto a cada 'progressao' minutos
            const discountMultiples = Math.floor(totalDuration / progressao)
            totalGradeDiscount = discountMultiples * valor
          } else {
            // quando progressao é null, aplica o desconto apenas uma vez
            totalGradeDiscount = valor
          }
          gradeTotalValue -= totalGradeDiscount
          totalDiscount += totalGradeDiscount
        }
      }

      totalValue += gradeTotalValue
    })

    setDiscountValue(totalDiscount > 0 ? totalDiscount.toFixed(2).replace('.', ',') : 0)

    return totalValue.toFixed(2).replace('.', ',')
  }, [sttPg.selectedHorarios, sttPg.selectedQuadra?.grades])

  function sendToCheckout() {
    const objtCkt = {
      horarioAvulso: true,
      agenda: sttPg.selectedHorarios.sort(
        (a, b) => new Date(a.dataInicio) - new Date(b.dataInicio),
      ),
      quadra: sttPg.selectedQuadra,
      valorDesconto: discountValue ? parseFloat(discountValue.replace(',', '.')) : 0,
      valorTotal: parseFloat(calculateTotalValue.replace(',', '.')),
      dia: moment(sttPg.selectedDay).format(),
    }

    let categoria = null
    if (Object.keys(reagendamento).length > 0) {
      const categoriaExists = sttPg.selectedQuadra.categoriasEsporte.some(
        cat => cat.idcategoriaEsporte === reagendamento.categoriaEsporte.idcategoriaEsporte,
      )
      categoria = categoriaExists ? reagendamento.categoriaEsporte : null
    } else if (
      sttPg.selectedQuadra.categoriasEsporte.length === 1 &&
      Object.keys(reagendamento).length === 0
    ) {
      categoria = sttPg.selectedQuadra.categoriasEsporte[0]
    }

    const tipoPagamentoQuadra = sttPg.selectedQuadra.regraAgendamento.tipoPagamento

    const buffer = {
      agendamentoConfirme: objtCkt,
      esporteSelected: categoria,
      cpfObrigatorio: null,
      metodPay: null,
      cupomAplicado: null,
      selTotal:
        tipoPagamentoQuadra === 'TOTAL' ||
        (Object.keys(reagendamento).length > 0 &&
          (reagendamento.valorAPagar === reagendamento.valorTotal - reagendamento.valorDesconto ||
            reagendamento.valorRealizado ===
              reagendamento.valorTotal - reagendamento.valorDesconto))
          ? true
          : false,
      selSinal:
        tipoPagamentoQuadra === 'SINAL' ||
        (Object.keys(reagendamento).length > 0 &&
          reagendamento.valorRealizado !== 0 &&
          reagendamento.valorRealizado !== reagendamento.valorTotal - reagendamento.valorDesconto)
          ? true
          : false,
      selPix:
        Object.keys(reagendamento).length > 0
          ? reagendamento.formaPagamento === 'PIX' &&
            sttPg.selectedQuadra.regraAgendamento.recebimentos_pix_avulso
          : false,
      selCardCredit:
        Object.keys(reagendamento).length > 0
          ? reagendamento.formaPagamento === 'CARTAO_CREDITO' &&
            sttPg.selectedQuadra.regraAgendamento.recebimentos_cartao_avulso
          : false,
      selMaqCredit:
        Object.keys(reagendamento).length > 0
          ? reagendamento.formaPagamento === 'MAQUINA_CARTAO' &&
            sttPg.selectedQuadra.regraAgendamento.recebimentos_maquina_local_avulso
          : false,
      selDinheiro:
        Object.keys(reagendamento).length > 0
          ? reagendamento.formaPagamento === 'DINHEIRO' &&
            sttPg.selectedQuadra.regraAgendamento.recebimentos_dinheiro_avulso
          : false,
      diaria: null,
    }

    LocalStorage.set('agendamento-selecionado', objtCkt)
    actionsChkt.handleSttCtxBuff(buffer)
    actionsCtxEmps.confirmarPedido()
  }

  let minAgendavel = null
  if (sttPg.selectedHorarios.length !== 0) {
    minAgendavel = sttPg.selectedQuadra?.grades.find(
      gd => gd.idgrade === sttPg.selectedHorarios[0].idgrade,
    ).minimoAgendavel
  }

  return (
    <Box
      sx={{
        ...stMob.containFixedResumo,
        opacity: `${
          sttPg.selectedHorarios.length === 0 ||
          (Object.keys(reagendamento).length > 0 &&
            !pagamentoLocal &&
            parseFloat(calculateTotalValue.replace(',', '.')) !== reagendamento.valorTotal)
            ? 0.5
            : Services.IsMinAgendavel(sttPg.selectedHorarios) < minAgendavel
              ? 0.5
              : 1
        }`,
      }}
    >
      <button
        onClick={sttAuthCtx.isLogged ? sendToCheckout : () => serverRouter('login')}
        style={{ width: '100%', height: '100%' }}
        disabled={
          sttPg.selectedHorarios.length === 0 ||
          (Object.keys(reagendamento).length > 0 &&
            !pagamentoLocal &&
            parseFloat(calculateTotalValue.replace(',', '.')) !== reagendamento.valorTotal)
        }
      >
        {sttPg.selectedHorarios.length === 0 ||
        (Object.keys(reagendamento).length > 0 &&
          !pagamentoLocal &&
          parseFloat(calculateTotalValue.replace(',', '.')) !== reagendamento.valorTotal) ? (
          <Grid container>
            <Grid item xs={12}>
              <Typography variant='body1' align='center' color='white'>
                {Object.keys(reagendamento).length === 0
                  ? 'Selecione os horários desejados'
                  : pagamentoLocal
                    ? 'Selecione os novos horários desejados'
                    : `O novo horário deve ter valor igual à R$ ${reagendamento.valorTotal.toFixed(2).replace('.', ',')}${
                        sttPg.selectedHorarios.length > 0
                          ? ', você selecionou R$ ' + calculateTotalValue
                          : ''
                      }`}
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
            <Grid
              item
              xs={7}
              sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
            >
              <Typography variant='body1' sx={stMob.labelHorario}>
                {`${moment(sttPg.selectedHorarios[0].dataInicio).format('HH:mm')} às ${moment(
                  sttPg.selectedHorarios[sttPg.selectedHorarios.length - 1].dataFinal,
                ).format('HH:mm')}`}
              </Typography>
              <Typography variant='body2' align='left' color='white'>
                {`${Services.TruncateString(sttPg.selectedQuadra?.descricao, 15)}, ${Services.TruncateString(sttPg.empresa.nome, 25)}`}
              </Typography>
            </Grid>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'end',
                alignItems: 'center',
              }}
            >
              <Box sx={stMob.containValues}>
                {Object.keys(reagendamento).length > 0 &&
                  !pagamentoLocal &&
                  reagendamento.valorTotal !== parseFloat(calculateTotalValue) && (
                    <Typography variant='subtitle2' color='primary.contrastText'>
                      Saldo excedente:
                    </Typography>
                  )}
                {discountValue !== 0 && (
                  <Typography variant='body2' sx={stMob.textDesc}>
                    - R$ {discountValue}
                  </Typography>
                )}
                <Typography variant='body2' sx={stMob.textValue}>
                  {!sttAuthCtx.isLogged
                    ? 'Entrar'
                    : Services.IsMinAgendavel(sttPg.selectedHorarios) < minAgendavel
                      ? `Agende no mínimo: ${Services.FormatDuration(minAgendavel, true)}`
                      : Object.keys(reagendamento).length > 0
                        ? pagamentoLocal
                          ? `R$ ${calculateTotalValue}`
                          : reagendamento.valorTotal === parseFloat(calculateTotalValue)
                            ? 'Sem custos'
                            : `R$ ${(parseFloat(calculateTotalValue.replace(',', '.')) - reagendamento.valorTotal).toFixed(2).replace('.', ',')}`
                        : `R$ ${calculateTotalValue}`}
                </Typography>
              </Box>
              <IoIosArrowForward style={stMob.iconBar} />
            </Grid>
          </Grid>
        )}
      </button>
    </Box>
  )
}

const stMob = {
  containFixedResumo: {
    padding: '10px',
    height: '75px',
    width: '100%',
    borderRadius: '16px 16px 0 0',
    background: 'linear-gradient(90deg, rgba(255,112,67,1) 40%, rgba(173,50,14,1) 100%)',
    zIndex: 1,
  },
  textDesc: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    backgroundColor: '#11bf68',
    padding: '4px 8px 3px 8px',
    borderRadius: '14px',
    textAlign: 'center',
    color: '#006b2d',
    marginBottom: '3px',
    fontSize: '0.8rem',
  },
  labelHorario: { color: 'white', fontWeight: 'bold', fontSize: '1.1rem', textAlign: 'left' },
  iconBar: { color: 'white', minWidth: '25px', minHeight: '25px', marginLeft: '10px' },
  textValue: { color: 'white', fontWeight: 'bold', fontSize: '1.13rem', textAlign: 'right' },
  containValues: { display: 'flex', flexDirection: 'column', justifyContent: 'center' },
}
